import Image from "next/future/image";

import { useRouter } from "next/dist/client/router";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import SwiperCore, { Autoplay } from "swiper";
SwiperCore.use([Autoplay]);

import { Container } from "react-bootstrap";
import SectionHead from "../Shared/SectionHead";
import { useIntl } from "react-intl";
const Partners = ({ partnersData }) => {
  const { locale } = useRouter();
  const { formatMessage } = useIntl();
  const renderPartners = partnersData?.map((partner, idx) => {
    return (
      <SwiperSlide key={idx}>
        <div className="partner-item">
          <Image
            src={`${process.env.NEXT_PUBLIC_MAIN_URL}${partner?.image?.path}`}
            width={150}
            height={100}
            alt=""
            loading="lazy"
          />
        </div>
      </SwiperSlide>
    );
  });

  return (
    <>
      <div
        className="partners"
        data-aos="fade-up"
        data-aos-duration="300"
        data-aos-delay="100"
      >
        <Container>
          <div className="d-flex justify-content-center align-items-end w-100 ">
            <SectionHead title={formatMessage({ id: "partners" })} />
          </div>
          <Swiper
            dir={locale}
            loop={false}
            spaceBetween={30}
            slidesPerView={6}
            centeredSlides={false}
            breakpoints={{
              320: {
                slidesPerView: 1.5,
                centeredSlides: true,
              },
              640: {
                slidesPerView: 2,
              },
              991: {
                slidesPerView: 3,
              },
              1024: {
                slidesPerView: 6,
              },
            }}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            className="mySwiper"
          >
            {renderPartners}
          </Swiper>
        </Container>
      </div>
    </>
  );
};

export default Partners;
